var _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgIconPlus = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1242",
    "data-name": "Group 1242",
    width: 14.139,
    height: 14.786,
    viewBox: "0 0 14.139 14.786",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1075",
    "data-name": "Group 1075"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_85",
    "data-name": "Ellipse 85",
    transform: "translate(0.059)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.7
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.777,
    cy: 7.393,
    rx: 6.777,
    ry: 7.393,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.777,
    cy: 7.393,
    rx: 6.427,
    ry: 7.043,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_24px_1_",
    "data-name": "24px (1)",
    transform: "translate(0 0.324)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2460",
    "data-name": "Path 2460",
    d: "M0,0H14.139V14.139H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2461",
    "data-name": "Path 2461",
    d: "M12.659,9.713H9.713v2.946a.589.589,0,1,1-1.178,0V9.713H5.589a.589.589,0,0,1,0-1.178H8.535V5.589a.589.589,0,0,1,1.178,0V8.535h2.946a.589.589,0,1,1,0,1.178Z",
    transform: "translate(-2.054 -2.054)",
    fill: "#fff"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconPlus, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon_plus.85e671ea.svg";
export { ForwardRef as ReactComponent };